const PasswordHide = () => (
  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.815092 6.53488C0.712952 6.37315 0.661882 6.29229 0.633293 6.16756C0.611819 6.07387 0.611819 5.92613 0.633293 5.83244C0.661882 5.70771 0.712952 5.62685 0.815092 5.46512C1.65915 4.12863 4.17155 0.75 8.0003 0.75C11.8291 0.75 14.3415 4.12863 15.1855 5.46512C15.2877 5.62685 15.3387 5.70771 15.3673 5.83244C15.3888 5.92613 15.3888 6.07387 15.3673 6.16756C15.3387 6.29229 15.2877 6.37315 15.1855 6.53488C14.3415 7.87137 11.8291 11.25 8.0003 11.25C4.17155 11.25 1.65915 7.87137 0.815092 6.53488Z"
      stroke="#667085"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.0003 8.25C9.24294 8.25 10.2503 7.24264 10.2503 6C10.2503 4.75736 9.24294 3.75 8.0003 3.75C6.75766 3.75 5.7503 4.75736 5.7503 6C5.7503 7.24264 6.75766 8.25 8.0003 8.25Z"
      stroke="#667085"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PasswordHide;
